<content *ngIf="workoutSession">
  <header fxLayout="column">
    <h2>{{ workoutSession.workout.name }}</h2>
    <div
      *ngIf="timeElapsed"
      fxLayout="row"
      fxLayoutGap=".1em"
      fxLayoutAlign="center center"
    >
      <mat-form-field class="input-time" fxFlex="20">
        <label>Minutes</label>
        <input
          matInput
          type="number"
          [ngModel]="timeMinutes"
          (input)="onTimeChange($event, 'minutes')"
          [disabled]="isHistory"
        />
      </mat-form-field>
      <div class="input-time-spacer">:</div>
      <mat-form-field class="input-time" fxFlex="20">
        <label>Seconds</label>
        <input
          matInput
          type="number"
          [ngModel]="timeSeconds"
          (input)="onTimeChange($event, 'seconds')"
          [disabled]="isHistory"
        />
      </mat-form-field>
    </div>
    <div>
      <p>How was your workout?</p>
      <div fxLayoutAlign="center center">
        <span class="rep-score">{{ rpeScore }}</span
        >&nbsp;&nbsp;({{ repStrings[rpeScore] }})
      </div>
      <p></p>
      <mat-slider
        class="rpe-slider"
        max="10"
        min="0"
        step="1"
        tickInterval="1"
        thumbLabel="true"
        [disabled]="isHistory"
        [(ngModel)]="rpeScore"
      >
        <input matSliderThumb [value]="rpeScore" (valueChange)="onSliderChange($event)">
      </mat-slider>
    </div>
  </header>
  <main style="min-width:100%;max-width:100%;" fxLayout="column" fxLayoutAlign="start center">
    <mat-accordion fxFlex fxLayout="column">
      <ng-container
        *ngFor="let tier of (workoutSession$ | async).workout.tiers; let tierIndex = index"
        style="width:100%;"
      >
        <div *ngIf="tier && tier.circuit && tier.circuit.executions && tier.circuit.executions.length > 0">
          <mat-expansion-panel style="width:100%;">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div
                  fxFlex
                  fxLayout="row"
                  fxLayoutGap="5px"
                  fxLayoutAlign="center center"
                >
                  <mat-icon>loop</mat-icon>
                  <div>{{ tier.name }}</div>
                  <div fxFlex></div>
                  <mat-icon
                    *ngIf="!tier.comments || !isHistory"
                    class="small"
                    (click)="openCommentsDialog(tierIndex, -1)"
                    >edit</mat-icon
                  >
                  <mat-icon
                    *ngIf="tier.comments"
                    class="small"
                    (click)="openCommentsDialog(tierIndex, -1)"
                    >comment</mat-icon
                  >
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div fxLayout="column">
              <div
                fxFlex
                fxLayout="row"
                fxLayoutAlign="center center"
                fxLayoutGap="20px"
                style="border-bottom: 1px #fff solid;padding-bottom:10px;"
              >
                <div fxFlex="45%">Circuit Rounds Completed</div>
                <div
                  class="rounds"
                  *ngIf="
                    tier.circuit &&
                    tier.circuit.executions.length &&
                    tier.circuit.executions[0].num_rounds &&
                    tier.circuit.executions[0].num_rounds !== -1
                  "
                  fxLayoutAlign="start center"
                  fxFlex="45%"
                >
                  {{ tier.circuit.executions[0].num_rounds }} Rounds
                </div>
                <div fxFlex="10%">
                  <button
                    *ngIf="!isHistory"
                    mat-button
                    (click)="openEditTier(tierIndex)"
                  >
                    Edit
                  </button>
                </div>
              </div>              
              <div
                fxLayout="column"
                fxLayoutGap="20px"
                fxLayoutAlign="space-between"
                fxFlex
              >
                <div fxFlex></div>
                <div
                  *ngFor="let row of tier.rows; let rowIndex = index"
                  fxLayout="row"
                  fxLayoutAlign="space-between"
                  fxFlex
                >
                  <div
                    *ngIf="row && rowIndex > -1"
                    fxLayout="row"
                    fxLayoutAlign="space-between"
                    fxFlex
                  >
                    <div fxFlex="45%">
                      <strong>{{ row.exercise.name }}</strong>
                    </div>
                    <!-- <div fxFlex></div> -->
                    <app-exercise-set-item
                      fxFlex="45%"
                      [workoutSession]="workoutSession"
                      [isHistory]="true"
                      [execution]="row.executions && row.executions[0]"
                      [currentWorkoutIndex]="tierIndex"
                      [currentRowIndex]="rowIndex"
                      [setIndex]="0"
                    >
                    </app-exercise-set-item>
                    <!-- <div fxFlex></div> -->
                    <div
                      class="rounds"
                      fxLayout="column"
                      fxLayoutAlign="center center"
                      fxFlex="10%"
                    >
                      <button
                        *ngIf="!isHistory && row && rowIndex > -1"
                        mat-button
                        (click)="openEditCircuitDialog(tierIndex, rowIndex)"
                      >
                        Edit
                      </button>
                    </div>
                  </div>
                </div>
                <div fxFlex></div>
              </div>
            </div>
          </mat-expansion-panel>
        </div>
        <div *ngIf="tier && !tier.circuit || !tier.circuit.executions || tier.circuit.executions.length === 0">
          <mat-expansion-panel
            *ngFor="let row of tier.rows; let rowIndex = index"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div
                  fxFlex
                  fxLayout="row"
                  fxLayoutAlign="center center"
                  fxLayoutGap="5px"
                >
                  <div>{{ row.exercise.name }}</div>
                  <div fxFlex></div>
                  <mat-icon
                    *ngIf="!row.comments"
                    class="small"
                    (click)="openCommentsDialog(tierIndex, rowIndex)"
                    >edit</mat-icon
                  >
                  <mat-icon
                    *ngIf="row.comments"
                    class="small"
                    (click)="openCommentsDialog(tierIndex, rowIndex)"
                    >comment</mat-icon
                  >
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="exercise-notes" *ngIf="row.notes">
              {{ row.notes }}
              <hr />
            </div>
            <div
              *ngFor="let execution of row.executions; let setIndex = index"
              fxLayout="row"
              fxLayoutGap="20px"
            >
              <div fxLayoutAlign="center center">Set {{ setIndex + 1 }}</div>
              <div
                fxLayout="row"
                fxLayoutGap="5px"
                fxLayoutAlign="center center"
              >
                <app-exercise-set-item
                  fxFlex="1 1"
                  [workoutSession]="workoutSession"
                  [isHistory]="true"
                  [execution]="execution"
                  [currentWorkoutIndex]="tierIndex"
                  [currentRowIndex]="rowIndex"
                  [setIndex]="setIndex"
                ></app-exercise-set-item>
              </div>
              <div fxFlex></div>
              <div
                *ngIf="execution.complete_time"
                fxLayoutAlign="center center"
              >
                <mat-icon>check_mark</mat-icon>
              </div>
              <div>
                <button
                  *ngIf="!isHistory"
                  mat-button
                  (click)="openEditSet(tierIndex, rowIndex, setIndex)"
                >
                  Edit
                </button>
              </div>
            </div>
          </mat-expansion-panel>
        </div>
      </ng-container>
    </mat-accordion>
  </main>
  <footer>
    <button
      *ngIf="isHistory && workoutSession && allowExecute"
      (click)="startNewWorkout()"
      mat-raised-button
      color="secondary"
      [disabled]="!allowExecute"
    >
      Start New Workout
    </button>
    <span fxFlex></span>
    <button
      *ngIf="!isHistory"
      (click)="saveWorkout()"
      mat-raised-button
      color="primary"
    >
      SAVE AND EXIT
    </button>
    <button
      *ngIf="isHistory"
      (click)="closeHistory()"
      mat-raised-button
      color="primary"
    >
      EXIT
    </button>
  </footer>
</content>
